/**
 * Session probe helpers for /api/auth/me and /api/agent/me.
 * 401 is treated as "not logged in" (not an axios error).
 */
import axios from 'axios';

export const B2C_SESSION_HINT_KEY = 'acf_b2c_session_hint';
export const AGENT_SESSION_HINT_KEY = 'acf_agent_session_hint';
export const STAFF_SESSION_HINT_KEY = 'acf_staff_session_hint';

/** Axios config: 401 is a valid "no session" response for /me probes. */
export const SESSION_ME_AXIOS_CONFIG = {
  validateStatus: (status) => status === 200 || status === 401,
};

export function hasSessionHint(key) {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return true;
  }
}

export function setSessionHint(key) {
  try {
    localStorage.setItem(key, '1');
  } catch {
    // ignore private mode / quota errors
  }
}

export function clearSessionHint(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

/**
 * GET a /me endpoint; returns axios response (status 200 or 401).
 */
export async function fetchSessionMe(url) {
  return axios.get(url, SESSION_ME_AXIOS_CONFIG);
}
